module.exports = __webpack_public_path__ + "img/benefit_la-bowl-field-passes.e829874d.jpg";